import type { SVGProps } from 'react';
import styled from 'styled-components';

import { unitMapping } from 'lib/style';

const Shape = styled.div`
  aspect-ratio: 0.935;
  clip-path: polygon(-50% 50%, 50% 100%, 150% 50%, 50% 0);
  @supports (clip-path: shape(from 0 0, close)) {
    /* stylelint-disable declaration-property-value-no-unknown */
    clip-path: shape(
      from 59.11% 2.22%,
      line to 90.92% 18.96%,
      curve to 100% 33.26% with 96.56% 21.92% / 100% 27.38%,
      vline to 66.74%,
      curve to 90.92% 81.04% with 100% 72.62% / 96.56% 78.08%,
      line to 59.11% 97.78%,
      curve to 40.89% 97.78% with 53.47% 100.74% / 46.53% 100.74%,
      line to 9.08% 81.04%,
      curve to 0% 66.74% with 3.44% 78.08% / 0% 72.62%,
      vline to 33.26%,
      curve to 9.08% 18.96% with 0% 27.38% / 3.44% 21.92%,
      line to 40.89% 2.22%,
      curve to 59.11% 2.22% with 46.53% -0.74% / 53.47% -0.74%,
      close
    );
    /* stylelint-enable declaration-property-value-no-unknown */
  }
`;

type Props = {
  className?: string;
  size?: keyof typeof unitMapping;
  inverted?: boolean;
  noBorder?: boolean;
} & Pick<SVGProps<SVGPathElement>, 'fill'>;

export const HexagonShape = ({
  className,
  fill: fillProp,
  size = 4,
  inverted,
  noBorder,
}: Props) => {
  const fill = fillProp || `var(--c-blue-400)`;

  if (inverted && noBorder) {
    return (
      <Shape
        className={className}
        style={{
          width: unitMapping[size],
          background: 'var(--c-nd-50)',
        }}
      />
    );
  }
  if (inverted) {
    return (
      <Shape
        className={className}
        style={{
          width: unitMapping[size],
          background: fill,
        }}
      >
        <Shape
          style={{
            width: '100%',
            transform: 'scale(0.9)',
            background: 'var(--c-black)',
          }}
        />
      </Shape>
    );
  }
  return (
    <Shape
      className={className}
      style={{
        width: unitMapping[size],
        background: fill,
      }}
    />
  );
};
